import { ExpanderCommon } from '../../internal/ExpanderCommon';
import { ExpanderList } from '../../internal/ExpanderList';
import { ExpanderText } from '../../internal/ExpanderText';

/**
 * Компонент для скрытия части контента с возможностью его развернуть и свернуть. Подходит для произвольного контента.
 * <br />
 * Работает на основе заданной высоты collapsedHeight.
 *
 * [Ссылка на макет](https://www.figma.com/design/il7C7QByCaIpFdBZcyhEGv/%F0%9F%8C%90-Expander)
 */
export const Expander = Object.assign(ExpanderCommon, {
  List: ExpanderList,
  Text: ExpanderText
});